import settings from 'Cloud/settings';

import store from './store';

const admitadIdParam = 'admitad_uid';
const admitadSavedIdParam = 'admitad_uid';

const getAdmitadIdFromRequest = () => {
    let id;

    if (settings && settings.request) {
        id = settings && settings.request.query_params[admitadIdParam];
    } else {
        const search = location.search.substr(1).split('&');

        search.forEach((param) => {
            param = param.split('=');

            if (param[0] === admitadIdParam) {
                id = param[1];
            }
        });
    }

    return id;
};

export const saveAdmitadId = () => {
    const id = getAdmitadIdFromRequest();

    if (id) {
        store.set(admitadSavedIdParam, id);
    }
};

export const getSavedAdmitadId = () => {
    return store.get(admitadSavedIdParam);
};
